import { mutatorAction } from 'satcheljs';
import {
    SharePointResourceTokenPrefetchStatus,
    SharePointResourceTokenPrefetchError,
} from '../Schema/SharePointResourceTokenPrefetchState';
import { parse as parseUrl } from 'url';
import { getSharePointResourceTokenPrefetchStateStore } from '../store/SharePointResourceTokenPrefetchStateStore';

const getAuthority = (url: string): string => {
    const webUri = parseUrl(url);
    return `${webUri.protocol}//${webUri.host}`;
};

export const updateSharePointResourceTokenPrefetchStateAction = mutatorAction(
    'updateSharePointResourceTokenPrefetchStateAction',
    function updateSharePointResourceTokenPrefetchState(
        resourceUrl: string,
        status: SharePointResourceTokenPrefetchStatus
    ) {
        resourceUrl = resourceUrl.toLowerCase();
        const authorityUrl = getAuthority(resourceUrl);
        const sharePointResourceTokenStateStore = getSharePointResourceTokenPrefetchStateStore();

        // Update or add new entry to the resource token map
        sharePointResourceTokenStateStore.tokenStatusPerResource.set(authorityUrl.toLowerCase(), {
            status: status,
        });
    }
);

export const updateSharePointResourceTokenPrefetchErrorStateAction = mutatorAction(
    'updateSharePointResourceTokenPrefetchErrorStateAction',
    function updateSharePointResourceTokenPrefetchErrorState(
        resourceUrl: string,
        error?: SharePointResourceTokenPrefetchError
    ) {
        resourceUrl = resourceUrl.toLowerCase();
        const authorityUrl = getAuthority(resourceUrl);
        const sharePointResourceTokenStateStore = getSharePointResourceTokenPrefetchStateStore();

        // Update or add new entry to the resource token map
        sharePointResourceTokenStateStore.tokenStatusPerResource.set(authorityUrl.toLowerCase(), {
            status: SharePointResourceTokenPrefetchStatus.Error,
            error: error,
        });
    }
);
